import { Banner } from '../components/banner/Banner'
import CelesteBan from '../assets/img/celeste-banner.avif'
import { WhatWeOffer } from '../layout/whatWeOffer/WhatWeOffer'
import { PageContainer } from '../components/pageContainer/PageContainer'
import { CompletedProjects } from '../layout/completedProjects/CompletedProjects'
import { HighStreetRetailShopping } from '../layout/highStreetRetailShopping/HighStreetRetailShopping'
import { CelesteShortcut } from '../layout/celesteShortcut/CelesteShortcut'

export const Home = () => {
    return (
        <PageContainer>
            <Banner img={CelesteBan} isHome />
            <WhatWeOffer />
            <CompletedProjects />
            <HighStreetRetailShopping />
            <CelesteShortcut />
        </PageContainer>
    )
}